import React from 'react';
import { CreditCard, Percent, Banknote, TrendingUp, Truck, CalendarClock, Landmark, Rocket } from 'lucide-react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { useTranslations } from '../hooks/useTranslations';
export function FundingSolutions() {
  const {
    t
  } = useTranslations();
  const solutions = [{
    icon: <CreditCard className="w-8 h-8 text-[#00E676]" data-id="element-186" />,
    title: t('solutions.card1.title'),
    description: t('solutions.card1.desc')
  }, {
    icon: <Percent className="w-8 h-8 text-[#00E676]" data-id="element-187" />,
    title: t('solutions.card2.title'),
    description: t('solutions.card2.desc')
  }, {
    icon: <Banknote className="w-8 h-8 text-[#00E676]" data-id="element-188" />,
    title: t('solutions.card3.title'),
    description: t('solutions.card3.desc')
  }, {
    icon: <TrendingUp className="w-8 h-8 text-[#00E676]" data-id="element-189" />,
    title: t('solutions.card4.title'),
    description: t('solutions.card4.desc')
  }, {
    icon: <Truck className="w-8 h-8 text-[#00E676]" data-id="element-190" />,
    title: t('solutions.card5.title'),
    description: t('solutions.card5.desc')
  }, {
    icon: <CalendarClock className="w-8 h-8 text-[#00E676]" data-id="element-191" />,
    title: t('solutions.card6.title'),
    description: t('solutions.card6.desc')
  }, {
    icon: <Landmark className="w-8 h-8 text-[#00E676]" data-id="element-192" />,
    title: t('solutions.card7.title'),
    description: t('solutions.card7.desc')
  }, {
    icon: <Rocket className="w-8 h-8 text-[#00E676]" data-id="element-193" />,
    title: t('solutions.card8.title'),
    description: t('solutions.card8.desc')
  }];
  return <section id="funding" className="py-20 bg-gray-50" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="text-center mb-16" data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-197">
            {t('solutions.title')}{' '}
            <span className="text-[#00E676]" data-id="element-198">
              {t('solutions.titleHighlight')}
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-199">
            {t('solutions.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-200">
          {solutions.map((solution, index) => <Card key={index} className="flex flex-col items-start h-full group cursor-pointer" data-id="element-201">
              <div className="p-3 bg-green-50 rounded-lg mb-4 group-hover:bg-[#00E676] transition-colors duration-300" data-id="element-202">
                <div className="group-hover:text-white transition-colors duration-300" data-id="element-203">
                  {solution.icon}
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-204">
                {solution.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-205">
                {solution.description}
              </p>
            </Card>)}
        </div>

        <div className="text-center" data-id="element-206">
          <Button size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-207">
            {t('solutions.cta')}
          </Button>
        </div>
      </div>
    </section>;
}